import {
  compose,
  css,
  layout,
  LayoutProps,
  space,
  SpaceProps,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { gap, GapProps, smBumps } from '../layout'

export type ListProps = LayoutProps & SpaceProps & GapProps

export const List = styled.ul<ListProps>(
  css({
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: smBumps,
  }),
  compose(layout, space, gap),
)
